import React from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Button,
  Badge,
  Form,
} from "react-bootstrap";
import { useWhitelabel } from "../../contexts/WhitelabelContext";

const TERMS_TEXT = `Terms and Conditions
M2M Connectivity Platform
These Terms and Conditions ("Agreement") govern the use of the M2M Connectivity Platform and related services provided by “CLICKSIMS S.A.”, a company organized under the laws of Greece, with its registered office at Perikleous 0, Thessaloniki ("Provider”) to any entity or individual using the platform ("Customer")
By accessing or using our Platform and Services, you agree to be bound by these Terms and Conditions. If you do not agree to these terms, you may not use our Services.
1. Definitions and Interpretation
1.1 "Business Day" means Monday through Friday, excluding public holidays in the Provider's jurisdiction.
1.2 "End User" means the end user of a SIM card or connectivity service provided through the Platform.
1.3 "M2M/IoT" means Machine-to-Machine / Internet of Things Services.
1.4 "Platform" or "M2M Connectivity Platform" means the online management tool, including API access and CDR reporting, provided to the Customer.
1.5 "Services" means all connectivity services, SIM management, technical support, and platform access provided under this Agreement.
1.6 "SIM" means a M2M SIM card provided to the Customer by the Provider.
1.7 "Active SIM/IMSI" means a SIM/IMSI that is activated on the Management Platform with all services active.
1.8 "Connected Networks" means networks over which the Provider will provide connectivity services.
1.9 "Connectivity Service" means the wireless transmission of data and SMS between the Provider's infrastructure and an installed and activated SIM.
1.10 "Term" means the duration of this Agreement as determined in accordance with the termination provisions.
1.11 "Territory" means the geographical area where Services are available as specified by the Provider.
2. Services
2.1 The Provider agrees to provide the Customer with the following services:
•	Access to the M2M Connectivity Platform
•	SIM cards and IMSI management
•	M2M Connectivity Services (data and SMS)
•	Technical support services
2.2 The Provider shall provide stable access to the Application Programming Interface ("API") for SIM card management including activation, deactivation, data limit configuration, and electronic usage reporting.
2.3 The Provider grants Customer a non-exclusive, fee-based, non-transferable, non-sublicensable, revocable and limited right to access the Platform and use the Services during the Term, solely for purposes indicated in this Agreement. Customer assumes full responsibility for all acts and omissions of Customer's End Users.
2.4 Customer shall be solely responsible for complying with all applicable laws, statutes, rules, regulations and ordinances with respect to the Services and Customer's performance under this Agreement. Customer shall obtain all necessary licenses, approvals and permits to use the Services.
2.5 Customer acknowledges that the Platform and Services contain trade secrets and proprietary information. Customer shall not reverse engineer, disassemble, decompile, or otherwise attempt to derive the underlying algorithms or other aspects of the Platform and Services.
2.6 Provider may collect, analyze and process usage data for business purposes including security, analytics, service improvement, and diagnostic purposes. Provider may disclose usage data only in aggregated and/or de-identified form that does not identify Customer or End Users.
3. Payment Terms
3.1 Prices for Services are based on the pricing list as notified to the Customer by the Provider.
3.2 The Provider shall give Customer thirty (30) days' notice in writing of any changes in prices for the Services.
3.3 Provider will send monthly invoices covering charges for the previous month. Each invoice will specify a description of each charge or category of charges. Fees shall be paid via wire transfer to the bank account specified on the invoice.
3.4 Customer shall be responsible for all applicable taxes, customs, duties, and tariffs. All invoices are payable within thirty (30) days of receipt, and late payments shall accrue interest at a rate of two percent (2%) per month. The payment due date and late-payment terms apply unless otherwise agreed in writing with the Customer.
3.5 Fees are exclusive of sales, use, value-added, excise, customs, export, import or similar taxes. Customer shall pay and hold Provider harmless from any such taxes.
3.6 Additional service costs for remediation of problems caused by Customer's negligence or improper use of the Platform will be charged separately.
3.7 Where payments are overdue, Provider is entitled to suspend Services or terminate the Agreement. Provider will send one written reminder before disconnection.
3.8 The monthly Platform usage fee is seven hundred euros (€700) per month, unless otherwise agreed in writing with the Customer.
3.9 An OnStock SIM card has a monthly fee of fifty cents (€0.50), unless otherwise specified
in writing with the Customer.
3.10 A SIM card deletion penalty of one euro and fifty cents (€1.50) per SIM card shall apply, unless otherwise specified in writing with the Customer.
4. Customer Obligations
4.1 Customer agrees to inform the Provider of any problems encountered with the Platform and Services, and to communicate any End User requirements or suggestions.
4.2 Customer agrees to conduct business in a manner that reflects favorably on the Platform, Services, and Provider's reputation, and to avoid deceptive, misleading, illegal and unethical practices.
4.3 Customer warrants it will not authorize or permit End Users to resell the Services.
4.4 Customer shall be solely responsible for delivery of service to End Users and shall comply with all applicable data protection, privacy, and other laws.
4.5 Customer is solely responsible for the contractual relationship with its customers and End Users, and shall impose all applicable requirements on End Users.
4.6 Customer shall be responsible for notifying the Provider of any SIM card deletion at least thirty (30) days in advance.
5. SIM Cards
5.1 Risk of loss, title, theft, damage, and misuse of SIM cards transfers from Provider to Customer upon shipment to Customer's designated destination.
5.2 Customer shall protect SIM cards against unauthorized use, theft or damage. Security codes must not be disclosed to unauthorized parties. Customer shall follow Provider's instructions regarding SIM card use, fraud prevention, and misuse.
5.3 Provider does not warrant that SIM cards will be uninterrupted or error-free. SIM cards are provided "AS IS" and Provider disclaims all warranties, express or implied, including implied warranties of merchantability and fitness for a particular purpose.
5.4 SIM cards will be made available based on best effort. Delivery times will be discussed between Customer and Provider prior to shipment.
5.5 If a SIM card is Dead On Arrival (DOA), Provider will replace it free of charge if notified within 14 days of delivery. SIM cards that malfunction after activation may be replaced for a fee.
6. Suspension of Services
6.1 Provider may suspend Services if Customer fails to meet any obligation under this Agreement. Provider may provide reasonable time to remedy the failure prior to suspension.
6.2 Provider may suspend Services for routine maintenance, keeping such maintenance to a minimum and providing advance notice where possible.
6.3 Provider may also suspend Services if: (a) Customer or End Users abuse the Service creating adverse network impact; (b) Provider receives a formal request from authorities; (c) fraud or regulatory violations occur.
6.4 Payment obligations continue during suspension. Suspension will be lifted when Customer fulfills all obligations within the specified period.
6.5 Customer will notify End Users that illegal activities and criminal offences using the Services are prohibited.
6.6 Customer shall indemnify Provider from all claims arising from End Users' illegal or unlawful use of the Services.
7. Provider Obligations
7.1 Provider will provide Customer with connection to Services in all available geographical areas during the Agreement term. Provider may change available areas or networks for commercial or regulatory reasons.
7.2 Provider shall provide updated lists of charges and available areas with reasonable notice when changes occur.
7.3 For platform software support, Provider undertakes to: inform Customer about new versions; provide new versions with manuals within fifteen (15) days of release; develop updates for regulatory compliance; and assist with installation when needed.
7.4 Provider does not warrant quality, adequacy or security of third-party telecommunications networks. Provider is not liable for defective operation of third-party networks.
7.5 Provider does not warrant protection against viruses, malware, hacking or other malicious third-party activities.
8. Intellectual Property Rights
8.1 Customer acknowledges that Provider retains all right, title and interest in: (i) Provider's Confidential Information; (ii) all intellectual property rights in the Platform, Services, and related materials; and (iii) all trademarks, trade names, logos and trade designations. No rights are granted except those expressly stated in this Agreement.
8.2 All intellectual property in Provider's services, software, hardware, data, and developments made during the Agreement remain solely owned by Provider.
8.3 Customer shall not reverse engineer, decompile, disassemble, or attempt to discover source code of the Platform or Services. Customer shall not copy, rent, lease, distribute, or transfer rights to the Platform or Services.
9. Confidentiality
9.1 "Confidential Information" means any information disclosed by one Party to the other which is regarded as confidential, including business processes, customer lists, pricing, technical information, and trade secrets. All Platform-related information is Confidential Information of Provider.
9.2 The Receiving Party shall not use or disclose Confidential Information except as expressly permitted, required by law, or disclosed to attorneys and accountants. Confidential Information shall only be used to perform obligations under this Agreement.
9.3 Confidentiality obligations do not apply to information that: (a) was already known without restriction; (b) was acquired from a third party; (c) was independently developed; (d) was approved for release; (e) is in the public domain; or (f) is required by law to be disclosed.
9.4 Press releases announcing this relationship require mutual agreement. Terms shall not be disclosed to third parties without prior written approval except as required by law.
9.5 All Confidential Information remains property of the Disclosing Party and shall be returned upon request or destroyed when no longer needed.
9.6 During the Agreement term and for five (5) years following termination, Customer shall not solicit Provider's End Users, suppliers, employees, or customers.
10. Indemnification
10.1 Each Party shall defend, indemnify and hold the other Party harmless from claims, losses, actions, demands or damages resulting from: (i) breach of representations and warranties; (ii) performance under this Agreement; (iii) false representations to End Users; or (iv) breach of obligations under this Agreement.

11. Limitation of Liability
11.1 In no event will Provider be liable for any direct, indirect, consequential, incidental, special, exemplary, or punitive damages arising from the Services, Platform or this Agreement, whether based on contract, tort, strict liability or other theory.
11.2 In no event will Provider's liability exceed the fees paid by Customer to Provider. Multiple claims will not enlarge this limit.
12. Term and Termination
12.1 This Agreement commences on the Effective Date and continues until terminated pursuant to these terms.
12.2 This Agreement may be terminated by mutual written agreement of the Parties.
12.3 Either party may terminate immediately upon written notice if the other party breaches any material term and fails to remedy within thirty (30) days of written notice. Either party may terminate immediately if the other party ceases operations or has bankruptcy proceedings filed that are not dismissed within sixty (60) days.
13. Consequences of Termination
13.1 Provisions intended to survive termination shall remain in full force and effect.
13.2 Termination shall not affect accrued rights, remedies, obligations or liabilities, including the right to claim damages for pre-existing breaches.
13.3 Upon termination, Customer shall remain responsible for all outstanding payments, immediately cease using the Platform, and return all Provider Confidential Information.
14. General Provisions
14.1 Independent Contractor
Each party operates as an independent contractor. This Agreement does not create any agency, employment, partnership, joint venture, or franchise relationship.
14.2 Notices
All notices shall be in writing and deemed given when: (i) delivered personally; (ii) sent by confirmed email; (iii) five (5) days after certified mail; or (iv) one (1) business day after overnight carrier deposit.
14.3 Assignment
Customer may not assign this Agreement without Provider's prior written consent. Any purported transfer shall be void.
14.4 Governing Law
This Agreement shall be governed by the laws of [Jurisdiction]. Legal proceedings shall be brought in the courts of [Location].
14.5 Entire Agreement
This Agreement supersedes all prior agreements regarding the subject matter hereof.
14.6 Modification
Any provision may be amended only with written consent of both parties.
14.7 Severability
If any provision is held unenforceable, it shall be limited to the minimum extent necessary so this Agreement remains enforceable.
14.8 Force Majeure
Neither party shall be liable for delays due to causes beyond reasonable control.
15. Service Level Agreement
15.1 Provider will provide Services with specified availability and support levels as described in the applicable Service Level Agreement.
15.2 Technical support is available via ticket system and email/telephone during business hours.
15.3 Response times are based on severity levels:
•	Severity Level 1 (Platform unavailable): 6 hours response time
•	Severity Level 2 (Severely affected operations): 2 business days
•	Severity Level 3 (Minor issues): 3 business days
15.4 Core network service availability target is 99.7% per month, excluding scheduled maintenance.
15.5 For scheduled maintenance, Provider will provide at least forty-eight (48) hours' notice including timing and any service impact.
16. Contact Information
For questions about these Terms and Conditions, please contact:
Company: CLICKSIMS S.A 
Address: Perikleous 0, Thessaloniki, Greece
Email: support@clicksims.com 
Phone: +302313082163`;

const TermsAndConditions = () => {
  const paragraphs = React.useMemo(() => TERMS_TEXT.split(/\n\s*\n/), []);

  return (
    <div className="bg-light min-vh-100 py-5">
      <Container>
        <Row className="justify-content-center">
          <Col xs={12} lg={10} xl={8}>
            {/* Header */}
            <div className="d-flex justify-content-between align-items-center mb-4">
              <div>
                <h2 className="mb-1">M2M Connectivity Platform</h2>
                <div className="text-muted small d-flex align-items-center gap-2">
                  <Badge bg="primary" pill>
                    Terms &amp; Conditions
                  </Badge>
                  <span>Legal Agreement</span>
                </div>
              </div>
              {/* <div className="d-none d-md-flex gap-2">
                <Button
                  variant="outline-secondary"
                  size="sm"
                  onClick={handleDownloadPdf}
                >
                  PDF (with watermark)
                </Button>
                <Button
                  variant="outline-secondary"
                  size="sm"
                  onClick={handleDownloadDocx}
                >
                  DOCX
                </Button>
              </div> */}
            </div>

            <Card className="shadow border-0 rounded-4 overflow-hidden">
              {/* Top bar */}
              <Card.Header className="bg-white border-0 py-3 px-4">
                <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-3">
                  <div>
                    <div className="fw-semibold">Terms and Conditions</div>
                    <div className="text-muted small">
                      Please read this agreement carefully before using the
                      platform.
                    </div>
                  </div>
                </div>
              </Card.Header>

              {/* Scrollable, nicely formatted content */}
              <Card.Body
                className="px-4 pt-3 pb-4"
                style={{
                  maxHeight: "70vh",
                  overflowY: "auto",
                  background:
                    "radial-gradient(circle at top, #ffffff 0, #f9fafb 45%, #f3f4f6 100%)",
                }}
              >
                <div
                  style={{
                    fontFamily:
                      '-apple-system, BlinkMacSystemFont, "Segoe UI", system-ui, sans-serif',
                    fontSize: "0.95rem",
                    lineHeight: 1.7,
                    color: "#212529",
                  }}
                >
                  {paragraphs.map((paragraph, idx) => (
                    <div
                      key={idx}
                      className="mb-3 pb-2"
                      style={{
                        borderLeft:
                          idx === 0
                            ? "4px solid rgba(13,110,253,.45)"
                            : "1px solid rgba(0,0,0,0.03)",
                        paddingLeft: "0.9rem",
                        backgroundColor:
                          idx === 0 ? "rgba(13,110,253,0.02)" : "transparent",
                        borderRadius: "0 0.5rem 0.5rem 0",
                      }}
                    >
                      <p className="mb-0">
                        {paragraph.split("\n").map((line, i, arr) => (
                          <React.Fragment key={i}>
                            {line}
                            {i < arr.length - 1 && <br />}
                          </React.Fragment>
                        ))}
                      </p>
                    </div>
                  ))}
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default TermsAndConditions;
